import { render, staticRenderFns } from "./BaseConfirmDialog.vue?vue&type=template&id=505091c3&scoped=true"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505091c3",
  null
  
)

export default component.exports